/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvNameLabel}}</label>
                  <input
                    v-model="vmGPathAptitudeFormData.name"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationdescription">
                    {{cvDescriptionLabel}}</label>
                  <textarea
                    v-model="vmGPathAptitudeFormData.description"
                    type="text"
                    class="form-control textarea"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationimage">
                    {{cvImageLabel}}</label>
                  <input
                    v-model="vmGPathAptitudeFormData.image"
                    type="text"
                    class="form-control"
                    required/>
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="gpath_aptitudeAdd()">
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { GPathAptitudes } from "../../../FackApi/api/GPathAptitude"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "GPathAptitudeAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      apiName: "gpath_aptitude_add",
      cvCardTitle: "Add GPaths Aptitude",
      cvCardSubHeader: "Add GPaths Aptitude ",
      cvSubmitBtn: "Add",
      cvNameLabel: "name",
      cvDescriptionLabel: "description",
      cvImageLabel: "image",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "GPathAptitude Add Response",
      vmGPathAptitudeFormData: Object.assign({}, this.initFormData()),
      vmGPathAptitudeDesc: null,
      vmGPathAptitudeType: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "name": "",
        "description": "",
        "image": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGPathAptitudeFormData) {
          if (!this.vmGPathAptitudeFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * gpath_aptitudeAdd
     */
    async gpath_aptitudeAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true
        let gpathAptitudeAddResp = await GPathAptitudes.gpath_aptitudeAdd(this, this.vmGPathAptitudeFormData)
        await ApiResponse.responseMessageDisplay(this, gpathAptitudeAddResp)
        if (gpathAptitudeAddResp && !gpathAptitudeAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGPathAptitudeAddModal", gpathAptitudeAddResp.resp_data)
        }
        this.vmGPathAptitudeFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at gpath_aptitudeAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
